<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-button class="upLoadBtn" @click="handleAdd">上传</el-button>
        </el-form-item>

        <el-input
          style="float: right; margin-right: 20px"
          placeholder="通过编号/患者姓名/文件编码搜索"
          v-model="input3"
          class="input-with-select"
          :maxlength="10"
        >
          <el-button slot="append" icon="search" @click="searchBtn"></el-button>
        </el-input>
      </el-form>
    </el-col>

    <div
      style="
        float: left;
        margin-left: 20px;
        margin-top: -30px;
        margin-bottom: 10px;
      "
    >
      <h3>文件列表</h3>
      <div style="display: flex; margin-left: 150px; margin-top: -35px">
        <el-radio-group v-model="dataType" @change="changeHandler">
          <!-- (0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏') -->
          <el-radio class="radio" label="-1">全部</el-radio>
          <el-radio class="radio" label="0">肺</el-radio>
          <el-radio class="radio" label="1">泌尿</el-radio>
          <el-radio class="radio" label="2">神外</el-radio>
          <el-radio class="radio" label="3">肝胆</el-radio>
          <el-radio class="radio" label="4">心脏</el-radio>

          <el-radio class="radio" label="5">胰腺</el-radio>
          <el-radio class="radio" label="6">甲状腺</el-radio>
          <el-radio class="radio" label="7">耳鼻喉</el-radio>
          <el-radio class="radio" label="8">食管</el-radio>
          <el-radio class="radio" label="9">纵膈</el-radio>
          <el-radio class="radio" label="10">胸外</el-radio>
          <el-radio class="radio" label="11">普外</el-radio>
          <el-radio class="radio" label="12">骨科</el-radio>
          <el-radio class="radio" label="13">乳腺</el-radio>

          <el-radio class="radio" label="14">妇科</el-radio>
          <el-radio class="radio" label="15">胃肠</el-radio>
          <el-radio class="radio" label="16">血管</el-radio>
          <el-radio class="radio" label="17">腹腔</el-radio>
          <el-radio class="radio" label="18">盆腔</el-radio>
        </el-radio-group>
      </div>
    </div>

    <!--列表-->
    <!-- {{users}} -->
    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      @sort-change="changeSort"
      style="width: 100%"
    >
      <!-- <el-table-column prop="Index" label="序号" width="100">
			</el-table-column> -->
      <el-table-column label="序号" width="70px">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- <el-table-column type="index" label="序号" width="100" align="center" sortable></el-table-column> -->
      <el-table-column prop="FileNo" label="编号" align="center" min-width="95">
      </el-table-column>
      <el-table-column
        prop="DataType"
        label="数据类型"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.DataType | DataTypeFilter }}
        </template>
      </el-table-column>
      <el-table-column
        prop="PatientName"
        label="患者姓名"
        align="center"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="OrderTime"
        label="订单日期"
        align="center"
        min-width="140"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="FileCode"
        label="文件码"
        align="center"
        min-width="110"
      >
      </el-table-column>
      <el-table-column
        prop="Hospital"
        label="所属医院"
        align="center"
        min-width="160"
      >
      </el-table-column>
      <el-table-column
        prop="CreationTime"
        label="上传日期"
        align="center"
        min-width="170"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="Available"
        label="状态"
        align="center"
        min-width="55"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.Available == 0 ? "可用" : "停用" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
          <el-button
            class="editBtn"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            >查看</el-button
          >
          <el-button size="small" @click="handleDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../common/js/util";
//import NProgress from 'nprogress'
import {
  FileList,
  DeleteFile,
  getUserListPage,
  removeUser,
  batchRemoveUser,
  editUser,
  addUser,
} from "../../api/api";

export default {
  data() {
    return {
      filters: {
        name: "",
      },
      input3: "",
      users: [],
      total: 0,
      page: 1,
      isSort: 0,
      listLoading: false,
      sels: [], //列表选中列
      dataType: "-1",
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {},

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {},
    };
  },
  filters: {
    DataTypeFilter(value) {
      // [(0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')]
      if (value == 0) {
        return "肺";
      } else if (value == 1) {
        return "泌尿";
      } else if (value == 2) {
        return "神外";
      } else if (value == 3) {
        return "肝胆";
      } else if (value == "4") {
        return "心脏";
      } else if (value == 5) {
        return "胰腺";
      } else if (value == 6) {
        return "甲状腺";
      } else if (value == 7) {
        return "耳鼻喉";
      } else if (value == 8) {
        return "食管";
      } else if (value == 9) {
        return "纵膈";
      } else if (value == 10) {
        return "胸外";
      } else if (value == 11) {
        return "普外";
      } else if (value == 12) {
        return "骨科";
      } else if (value == 13) {
        return "乳腺";
      } else if (value == 14) {
        return "妇科";
      } else if (value == 15) {
        return "胃肠";
      } else if (value == 16) {
        return "血管";
      } else if (value == 17) {
        return "腹腔";
      } else if (value == 18) {
        return "盆腔";
      }
    },
  },
  methods: {
    // 数据类型改变
    changeHandler(value) {
      console.log("改变之后的值是:" + value);
      this.getUsers();
    },

    changeSort(column) {
      this.CurPage = 1;
      if (column.prop == "OrderTime" && column.order === "descending") {
        this.isSort = 4;
      } else if (column.prop == "OrderTime" && column.order === "ascending") {
        this.isSort = 3;
      } else if (
        column.prop == "CreationTime" &&
        column.order === "descending"
      ) {
        this.isSort = 2;
      } else if (
        column.prop == "CreationTime" &&
        column.order === "ascending"
      ) {
        this.isSort = 1;
      } else {
        this.isSort = 0;
      }
      this.getUsers();
    },
    searchBtn() {
      this.getUsers();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    //获取用户列表
    getUsers() {
      let para = {
        Page: this.page,
        Name: this.input3,
        IsSort: this.isSort,
        DataType: parseInt(this.dataType),
      };
      this.listLoading = true;
      console.log(para);

      FileList(para).then((res) => {
        console.log("+++++++++++++++++++++++++++++++++++++++res");
        console.log(res);
        this.users = res.List;
        this.total = res.total;
        // this.users = res.data.users;
        this.listLoading = false;
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = { FileCode: row.FileCode };
          DeleteFile(para).then((res) => {
            this.listLoading = false;

            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getUsers();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      console.log(row.FileCode);
      this.$router.push({
        path: "/fileInfo",
        query: { fileCode: row.FileCode },
      });
    },
    //显示新增界面
    handleAdd: function () {
      this.$router.push({ path: "/addFile" });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.birth =
              !para.birth || para.birth == ""
                ? ""
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            editUser(para).then((res) => {
              this.editLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getUsers();
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? ""
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            addUser(para).then((res) => {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getUsers();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map((item) => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getUsers();
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>

<style>
.editBtn {
  background: rgba(34, 107, 170, 1);
  color: rgba(255, 255, 255, 1);
}
.upLoadBtn {
  width: 100px;
  height: 30px;
  background: rgba(34, 107, 170, 1);
  border-radius: 4px;
  border: 1px solid rgba(83, 113, 255, 1);

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 8px;
}
.el-input {
  width: 330px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.toolbar {
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// FileList.vue?64fb522e